module.exports = __webpack_public_path__ + "img/banner.c217b628.png";